import script from "./CopywritingAide.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopywritingAide.vue?vue&type=script&setup=true&lang=ts"

import "./CopywritingAide.vue?vue&type=style&index=0&id=f46a1bfc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f46a1bfc"]])

export default __exports__